import React from 'react';
import { TableCell } from '@material-ui/core';
import { DropdownMenu } from '@nearst/ui';
import useSWR from 'swr';

import { searchProductCategories } from '@services/inventory';

import styles from './CategorySummary.module.scss';

const Category = ({ row }) => {
	const categoryId = row.category_ids?.[0];
	const needsFallback = !row.category_full_trees?.length && categoryId;

	const { data: fetchedCategory } = useSWR(needsFallback ? ['category', categoryId] : null, () =>
		searchProductCategories({ id: categoryId })
	);

	const categoryFullTree = row.category_full_trees?.[0] || fetchedCategory?.embedString;

	if (!row.category_titles?.length) return <TableCell />;

	return (
		<TableCell>
			<DropdownMenu
				buttonText={<span className={styles.mainCategoryTitle}>{row.category_titles[0]}</span>}
				className={styles.dropdown}
				innerClassName={styles.dropdownInner}
			>
				<p className={styles.categoryTitle}>Product category</p>
				<p className={styles.categoryValue}>{categoryFullTree || 'Loading...'}</p>
			</DropdownMenu>
		</TableCell>
	);
};

export { Category };
